/** layout: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "custom": "Custom",
  "customSmall": "custom",
  "fullScreen": "Full screen",
  "minimalist": "Minimalist Display",
  "l1": "Layout 1",
  "l2": "Layout 2",
  "l3": "Layout 3",
  "l4": "Layout 4",
  "l5": "Layout 5",
  "s_main": "Main",
  "s_ticker": "Ticker",
  "s_sidebar": "Sidebar",
  "s_left": "Left",
  "s_right": "Right",
  "s_center": "Center",
  "sectionN": "Section {n}",
  "selectX": "Select {name}",
  "sectionNameN": "Section {n} name",
  "f_x": "Section {n} x",
  "f_y": "Section {n} y",
  "f_width": "Section {n} width",
  "f_height": "Section {n} height",
  "sendX": "Send {name} backward",
  "bringX": "Bring {name} forward",
  "deleteX": "Delete {name}",
  "actionsFor": "Actions for {name}",
  "summary": "{w}×{h} · {n} section | {w}×{h} · {n} sections",
  "canvas": "Layout canvas",
  "resolution": "Resolution",
  "canvasWidth": "Canvas width",
  "canvasHeight": "Canvas height",
  "rotate": "⟳ Rotate Orientation",
  "addSection": "+ Add Section",
  "help": "Modify sections by dragging the preview or changing the values below. Edges snap to the canvas and to other sections. Arrow keys nudge the selected section (Shift = 10 px).",
  "section": "Section",
  "name": "Name",
  "width": "Width",
  "height": "Height",
  "actions": "Actions",
  "sendBackward": "Send backward",
  "bringForward": "Bring forward",
  "layout": "Layout",
  "newLayout": "+ New Layout",
  "layouts": "Layouts",
  "edit": "Edit",
  "delete": "Delete"
};
const ar: typeof en = {
  "custom": "مخصص",
  "customSmall": "مخصص",
  "fullScreen": "ملء الشاشة",
  "minimalist": "عرض بسيط",
  "l1": "التخطيط ١",
  "l2": "التخطيط ٢",
  "l3": "التخطيط ٣",
  "l4": "التخطيط ٤",
  "l5": "التخطيط ٥",
  "s_main": "الرئيسي",
  "s_ticker": "الشريط",
  "s_sidebar": "الشريط الجانبي",
  "s_left": "يسار",
  "s_right": "يمين",
  "s_center": "الوسط",
  "sectionN": "القسم {n}",
  "selectX": "تحديد {name}",
  "sectionNameN": "اسم القسم {n}",
  "f_x": "القسم {n} س",
  "f_y": "القسم {n} ص",
  "f_width": "عرض القسم {n}",
  "f_height": "ارتفاع القسم {n}",
  "sendX": "إرسال {name} للخلف",
  "bringX": "إحضار {name} للأمام",
  "deleteX": "حذف {name}",
  "actionsFor": "إجراءات {name}",
  "summary": "{w}×{h} · بلا أقسام | {w}×{h} · قسم واحد | {w}×{h} · قسمان | {w}×{h} · {n} أقسام | {w}×{h} · {n} قسمًا | {w}×{h} · {n} قسم",
  "canvas": "لوحة التخطيط",
  "resolution": "الدقة",
  "canvasWidth": "عرض اللوحة",
  "canvasHeight": "ارتفاع اللوحة",
  "rotate": "⟳ تدوير الاتجاه",
  "addSection": "+ إضافة قسم",
  "help": "عدّل الأقسام بسحب المعاينة أو تغيير القيم أدناه. تلتصق الحواف باللوحة وبالأقسام الأخرى. مفاتيح الأسهم تحرّك القسم المحدد (Shift = ١٠ بكسل).",
  "section": "القسم",
  "name": "الاسم",
  "width": "العرض",
  "height": "الارتفاع",
  "actions": "الإجراءات",
  "sendBackward": "إرسال للخلف",
  "bringForward": "إحضار للأمام",
  "layout": "التخطيط",
  "newLayout": "+ تخطيط جديد",
  "layouts": "التخطيطات",
  "edit": "تعديل",
  "delete": "حذف"
};
export default { en, ar };
